import { Directive, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { OverlayButtonComponent } from './overlay-button.component';

@Directive({
  selector: '[uiOverlayToggle]',
  standalone: true
})
export class OverlayToggleDirective {
  private readonly overlayButton = inject(OverlayButtonComponent, { host: true });

  public get isOpen(): Observable<boolean> {
    return this.overlayButton.overlayOpen$.asObservable();
  }

  public openOverlay(): void {
    this.overlayButton.open();
  }
}
